__turbopack_context__.v({
  "container": "DashboardComponentLink-module__NlFpOq__container",
});
